<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información de la Cuenta">
          <b-table 
              small 
              responsive="sm" 
              :busy="tableBusy"
              :items="bancoCuentaDatos" 
              :fields="campos">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
            <div slot="table-busy" class="text-center">
              <b-spinner variant="primary" label="Spinning" />
            </div>              
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item
              v-if="!readonly"
              @click.stop="editar">
            <i class="fa fa-edit"></i>Editar Datos de la Cuenta</b-dropdown-item>
          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>      
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'bancocuenta/getField',
  mutationType: 'bancocuenta/updateField',
});

export default {
  name: 'BancoCuentaDatos',
  components: {
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  data: () => {
    return {
      id: 0,
      campos: [
        {key: 'campo'},
        {key: 'valor'},
      ],
      tableBusy: false,
    }
  },
  created() {
    this.id= this.$route.params.id
    
    this.tableBusy = true;
    this.$store.dispatch('bancocuenta/getBancoCuentaDatos', this.id)
      .then(() => this.tableBusy = false)
      .catch(error => this.showErrorMsj(error));
  },  
  computed: {
    ...mapFields([
      'bancoCuentaDatos',
      'readonly'
    ]),
  },  
  methods: {
    goBack() {
      this.$router.push({ name: 'BancosCuentas' });
    },
    editar() {
      if (!this.readonly) {
        this.$router.push({ name: 'BancoCuentaABM', 
                            params: { id: this.id }});
      }
    },
  }
}
</script>
